(() => {
  const dialog = document.getElementById('nostalgia-vip');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  let opener;
  function open() {
    if (!dialog.open) dialog.showModal();
    const status = dialog.querySelector('[data-nostalgia-vip-status]:not([hidden])');
    const result = dialog.querySelector('[data-nostalgia-vip-result]');
    (status || result || dialog.querySelector('input[type="email"]') || dialog.querySelector('button')).focus();
  }
  document.querySelectorAll('[data-nostalgia-vip-open]').forEach(button => button.addEventListener('click', event => {
    event.preventDefault(); opener = button; open();
  }));
  dialog.querySelector('[data-nostalgia-vip-close]').addEventListener('click', () => dialog.close());
  const form = dialog.querySelector('form');
  const fields = form?.querySelector('[data-nostalgia-vip-fields]');
  const submit = form?.querySelector('button[type="submit"]');
  const email = form?.querySelector('input[type="email"]');
  const status = form?.querySelector('[data-nostalgia-vip-status]');
  if (form && fields && submit && email && status) {
    let submitting = false;
    let sending = false;
    let complete = false;
    let timeout;
    function restoreModal() {
      dialog.classList.remove('nostalgia-vip-verifying');
      if (dialog.open) { dialog.close(); dialog.showModal(); status.focus(); }
    }
    function showError() {
      window.clearTimeout(timeout);
      submitting = false;
      sending = false;
      fields.hidden = false;
      submit.disabled = false;
      status.style.minHeight = '';
      status.dataset.state = 'error';
      status.textContent = status.dataset.errorMessage;
      restoreModal();
    }
    async function send() {
      if (!submitting || sending || complete) return;
      sending = true;
      window.clearTimeout(timeout);
      const controller = new AbortController();
      timeout = window.setTimeout(() => controller.abort(), 25000);
      try {
        const response = await fetch(form.action, {
          method: 'POST', body: new URLSearchParams(new FormData(form)),
          credentials: 'same-origin', signal: controller.signal
        });
        const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!response.ok || !responseDocument.querySelector('#NostalgiaVipForm [data-nostalgia-vip-success]')) {
          throw new Error('Signup was not confirmed');
        }
        window.clearTimeout(timeout);
        complete = true;
        submitting = false;
        sending = false;
        status.dataset.state = 'success';
        status.textContent = status.dataset.successMessage;
        restoreModal();
      } catch { showError(); }
    }
    form.submit = send;
    form.addEventListener('submit', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitting || complete || !form.reportValidity()) return;
      submitting = true;
      dialog.close();
      dialog.show();
      dialog.classList.add('nostalgia-vip-verifying');
      status.style.minHeight = `${fields.getBoundingClientRect().height}px`;
      fields.hidden = true;
      status.hidden = false;
      status.dataset.state = 'loading';
      status.textContent = status.dataset.loadingMessage;
      status.focus();
      timeout = window.setTimeout(showError, 120000);
      if (typeof window.Shopify?.captcha?.protect !== 'function') { showError(); return; }
      try {
        window.Shopify.captcha.protect(form, () => {
          if (submitting) form.submit();
        });
      } catch { showError(); }
    });
  }
  dialog.addEventListener('close', () => { if (!dialog.open) { dialog.classList.remove('nostalgia-vip-verifying'); if (opener) opener.focus(); } });
  if (dialog.querySelector('[data-nostalgia-vip-result]')) open();
})();
